module.exports = __webpack_public_path__ + "img/電気回路_3_9_5.e0cc87f1.png";